
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment/response",
      function () {
        return require("private-next-pages/payment/response.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment/response"])
      });
    }
  